export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_shipmentPayStatementNo') || '付款结算单编号',
    field: 'shipmentPayStatementNo',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_shipmentContractNo') || '外运编号',
    field: 'shipmentContractNo',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_shipmentNo') || '发运单编号',
    field: 'shipmentNo',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_customer') || '客户',
    field: 'custName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyTotalAmount') || '费用合计',
    field: 'v_currencyTotalAmount',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'currencyTotalAmount' },
  },
  {
    title: that.$l('table_label_party') || '结算方',
    field: 'payScmName',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payer') || '付款方',
    field: 'payerName',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankName') || '结算方开户银行',
    field: 'bankName',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountName') || '结算方账户名称',
    field: 'bankAccountName',
    minWidth: 260,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountNo') || '结算方银行账号',
    field: 'bankAccountNo',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountType') || '结算方银行账户性质',
    field: 'v_bankAccountType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountKind') || '结算方银行账号类别',
    field: 'v_bankAccountKind',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_isAppend') || '是否为追加费用',
    field: 'isAppend',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'append' },
  },
  {
    title: that.$l('table_label_remark') || '账单说明',
    field: 'remark',
    minWidth: 350,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
]
